export default __webpack_public_path__ + "static/media/Template.28b7c24d.svg";